import request from "../../Request";
import {rThen} from "../../requestThen";

export let getPositions = async () => {

    return request.get(`/api/pedagogs/get_positions`, true).then(r => {
        return rThen(r);
    })
}